import styled from 'styled-components';

export const FilterBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
`;

export const FilterGroup = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FilterItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const Dropdown = styled.div`
  position: relative;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

export const DropdownSelect = styled.select`
  padding: 7px 11px;
  padding-right: 35px;
  position: relative;
  border-radius: 10px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: white;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  color: var(--Label-Strong, black);
  font-size: 15px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 22.01px;
  letter-spacing: 0.14px;
  word-wrap: break-word;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: var(--Label-Strong, #000);
  }

  &:disabled {
    background: #f7f7f8;
    color: rgba(55, 56, 60, 0.4);
    cursor: not-allowed;
  }
`;

export const DropdownButton = styled.button`
  padding: 7px 11px;
  padding-right: 35px;
  position: relative;
  border-radius: 10px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: white;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  color: var(--Label-Strong, black);
  font-size: 15px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 22.01px;
  letter-spacing: 0.14px;
  word-wrap: break-word;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  outline: none;
  text-align: left;

  &:focus {
    border-color: var(--Label-Strong, black);
  }
`;

export const DropdownIcon = styled.svg`
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--Label-Strong, black);
  pointer-events: none;
`;

export const DateFilter = styled.div`
  display: flex;
  align-items: center;
`;

export const DateGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const DateButton = styled(DropdownButton)`
`;

export const DateButtonText = styled.span`
  display: block;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DateButtonIcon = styled.svg`
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--Label-Strong, #000);
  pointer-events: none;
`;

export const DateLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #2e2f33;
  white-space: nowrap;
  min-width: 40px;
`;

export const DateSeparator = styled.div`
  font-size: 16px;
  color: rgba(55, 56, 60, 0.6);
  margin: 0 4px;
`;

export const DateInput = styled.input`
  width: 140px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  padding: 7px 11px;
  font-size: 15px;
  color: #171719;
  font-family: 'Pretendard Variable', sans-serif;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: var(--Label-Strong, #000);
  }

  &::placeholder {
    color: rgba(55, 56, 60, 0.4);
    font-size: 12px;
  }
`;

export const StatusFilter = styled.div`
  display: flex;
  align-items: center;
`;

export const StatusDropdown = styled(Dropdown)``;

export const StatusSelect = styled(DropdownSelect)`
  min-width: 0;
`;

export const SearchInputWrap = styled.div`
  flex: 0 1 250px;
  min-width: 180px;

  @media (max-width: 1024px) {
    width: 100%;
    flex-basis: 100%;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  height: 36px;
  padding: 8px;
  border-radius: 12px;
  outline: 1px solid var(--Line-Normal-Normal, rgba(112, 115, 124, 0.22));
  outline-offset: -1px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  box-sizing: border-box;
`;

export const SearchIcon = styled.div`
  width: 16px;
  height: 16px;
  padding-left: 2px;
  padding-right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(55, 56, 60, 0.4);
  opacity: 0.8;
  flex-shrink: 0;
`;

export const SearchField = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: var(--Label-Normal, #171719);
  font-size: 12px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 16.01px;
  letter-spacing: 0.3px;
  min-width: 0;

  &::placeholder {
    color: var(--Label-Assistive, rgba(55, 56, 60, 0.28));
    font-size: 12px;
    font-family: 'Pretendard Variable', sans-serif;
    font-weight: 400;
    line-height: 16.01px;
    letter-spacing: 0.3px;
  }
`;
